import {Injectable} from '@angular/core';
import {AfterPageViewEvent} from './events/after-page-view-event';
import {CxEvent, EventService} from '@spartacus/core';
import {EddlStBeaconEvent} from './events/eddl-stbeacon-event';
import {EddlStlBeaconEvent} from './events/eddl-stlbeacon-event';
import {EddlSearchInitiatedEvent} from './events/eddl-search-initiated-event';
import {EddlFormSubmitEvent} from './events/eddl-form-submit-event';
import {EddlFormErrorEvent} from './events/eddl-form-error-event';
import {EddlDownloadAttemptEvent} from './events/eddl-download-attempt-event';
import {EddlDownloadSuccessEvent} from './events/eddl-download-success-event';
import {EddlFormViewEvent} from './events/eddl-form-view-event';
import {EddlRemoveFromCartEvent} from './events/eddl-remove-from-cart-event';
import {EddlSearchNoResultsEvent} from './events/eddl-search-no-results-event';
import {PageEvent} from '@spartacus/storefront';
import {EddlSearchResultsClickEvent} from './events/eddl-search-results-click-event';
import {EddlAddToCartEvent} from './events/eddl-add-to-cart-event';
import {EddlCartCreatedEvent} from './events/eddl-cart-created-event';
import {EddlCartViewEvent} from './events/eddl-cart-view-event';
import {EddlCheckoutStartEvent} from './events/eddl-checkout-start-event';
import {EddlOrderCompleteEvent} from './events/eddl-order-complete-event';
import {EddlLogoutEvent} from '@app/services/analytics/EDDL/events/eddl-logout-event';
import {EddlLoginEvent} from '@app/services/analytics/EDDL/events/eddl-login-event';
import {ErrorPageEvent} from '@app/services/analytics/EDDL/events/error-page-event';
import {EddlBeaconKey} from '@app/services/analytics/EDDL/models/eddl-adobe-tracking-data';
import {EddlProductViewEvent} from '@app/services/analytics/EDDL/events/eddl-product-view-event';

@Injectable({
  providedIn: 'root'
})

export class DcpEddlDispatchService {
  stBeaconEventList = [
    AfterPageViewEvent,
    PageEvent,
    EddlOrderCompleteEvent,
    EddlCheckoutStartEvent,
    EddlCartViewEvent,
    ErrorPageEvent,
    EddlProductViewEvent
  ];
  stlBeaconEventList = [
    EddlCartCreatedEvent,
    EddlAddToCartEvent,
    EddlSearchInitiatedEvent,
    EddlSearchNoResultsEvent,
    EddlSearchResultsClickEvent,
    EddlFormSubmitEvent,
    EddlFormErrorEvent,
    EddlDownloadAttemptEvent,
    EddlDownloadSuccessEvent,
    EddlFormViewEvent,
    EddlRemoveFromCartEvent,
    EddlLogoutEvent,
    EddlLoginEvent,
  ];

  constructor(
    private events: EventService,
  ) {
  }

  public dispatchAfterPageViewEvent(): void {
    this.events.dispatch(new AfterPageViewEvent());
  }

  public triggerBeaconEvents<T extends CxEvent>(event: T): void {
    if (this.stBeaconEventList.some(className => event instanceof className)) {
      this.events.dispatch(new EddlStBeaconEvent());
    }
    if (this.stlBeaconEventList.some(className => event instanceof className)) {
      this.events.dispatch(new EddlStlBeaconEvent());
    }
  }

  public triggerBeaconEventManually(type: EddlBeaconKey): void {
    this.events.dispatch(type === EddlBeaconKey.ST ? new EddlStBeaconEvent() : new EddlStlBeaconEvent())
  }
}
